<template>
    <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <div>
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                        <i class="fas fa-coins" />
                        Criptoativos
                    </h2>
                </div>
                <balance :short="true" />
            </div>
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <menu-cripto />
                <flash :timeout="5000"/>
                <div class="flex justify-between items-center mt-6">
                    <h2
                        class="font-semibold text-xl text-gray-800 leading-tight"
                    >
                        Wallets
                    </h2>
                    <primary-button @click.native="registerWallet = true">
                        <i class="fas fa-plus mr-2" />Cadastrar nova wallet
                    </primary-button>
                </div>
                <div class="bg-white shadow-md sm:rounded-lg p-6 mt-6">
                    <inertia-table
                        id="cryptowalletss"
                        routeName="wallet.index"
                        :data="wallets"
                        :params="params"
                        :enableSearch="true"
                        :enable-pages="true"
                        :enable-display="true"
                        :columns="columns"
                        :hasLine="false"
                        :enableExport="false"
                        :hasIcon="false"
                        :icon="false"
                    >
                        <template slot-scope="row" slot="name">
                            <div class="text-sm">{{ row.item.name }}</div>
                        </template>
                        <template slot-scope="row" slot="status">
                            <span
                                class="rounded-full py-1 px-2 text-white font-semibold"
                                :class="getStatusColor(row.item)?.bg">
                                {{ getStatusColor(row.item)?.text }}
                            </span>
                        </template>
                        <template slot-scope="row" slot="created">
                            {{ `${moment(row.item.created).format('DD/MM/YYYY HH:mm')}` }}
                        </template>
                        <template slot-scope="row" slot="hash">
                            <copy-value :value="row.item.hash" tooltip="Copiar hash" />
                        </template>
                        <template slot-scope="{ item }" slot="delete">
                            <div
                                class="w-8 h-8 rounded-full flex justify-center items-center"
                                :class="colorDeleteIcon(item)"
                            >
                                <i
                                    v-tippy="'Excluir'"
                                    class="cursor-pointer fas fa-trash text-sm"
                                    @click="selectedWallet = item; confimWalletDelete = true"
                                />
                            </div>
                        </template>
                    </inertia-table>
                </div>
            </div>
        </div>

        <dialogs
            :confim-wallet-delete="confimWalletDelete"
            :register-wallet="registerWallet"
            :selected-wallet="selectedWallet"
            @close="registerWallet = false; confimWalletDelete = false"
        />
    </app-layout>
</template>
<script>
import moment from "moment";
import AppLayout from "./../../../Layouts/AppLayout.vue";
import Balance from "../../../Helpers/Balance.vue";
import TextField from "./../components/TextField.vue";
import SearchBar from "./../components/SearchBar";
import InertiaTable from "../../../Helpers/Tables/InertiaTable";
import icons from "./../utils/icons";
import JetDialogModal from "../../../Jetstream/DialogModal.vue";
import JetInputError from "../../../Jetstream/InputError";
import DropdownSelect from "./../components/DropdownSelect";
import Icons from "./../components/Icons";
import JetLabel from "../../../Jetstream/Label";
import ActionButtons from './../ActionButtons.vue';
import Flash from '../../../Helpers/Flash.vue';
import DialogModal from '../../../Jetstream/DialogModal.vue';
import MenuCripto from "./../components/MenuCripto.vue";
import CopyValue from "../../../Jetstream/CopyValue.vue";
import JetConfirmationModal from "../../../Jetstream/ConfirmationModal.vue";
import PrimaryButton from "../../../Jetstream/PrimaryButton.vue";
import SecondaryButton from "../../../Jetstream/SecondaryButton.vue";
import Dialogs from "./Dialogs.vue";

export default {
    props: ['wallets'],
    components: {
        AppLayout,
        Balance,
        Flash,
        InertiaTable,
        SearchBar,
        JetDialogModal,
        JetInputError,
        DropdownSelect,
        TextField,
        Icons,
        JetLabel,
        JetConfirmationModal,
        DialogModal,
        ActionButtons,
        MenuCripto,
        CopyValue,
        PrimaryButton,
        SecondaryButton,
        Dialogs
    },
    data() {
        return {
            moment,
            icons,
            confimWalletDelete: false,
            registerWallet: false,
            selectedWallet: {},
            columns: [
                {
                    text: "Wallet",
                    className: "text-left",
                    key: "name",
                    sortable: false
                },
                {
                    text: "Status",
                    className: "text-left",
                    key: "status",
                    sortable: false
                },
                {
                    text: "Moeda",
                    className: "text-left",
                    key: "currency",
                    sortable: false
                },
                {
                    text: "Rede",
                    className: "text-left",
                    key: "network",
                    sortable: false
                },
                {
                    text: "Data do cadastro",
                    className: "text-left",
                    key: "created",
                    sortable: false
                },
                {
                    text: "Hash",
                    className: "text-left",
                    key: "hash",
                    sortable: false
                },
                {
                    text: "",
                    className: "text-left",
                    key: "delete",
                    sortable: false
                },
            ],
            params: {
                sort: "name:asc",
                page: 1,
                ...this.$page.props.queryString
            },
        };
    },
    methods: {
        getStatusColor(item){
            switch (item.compliance_status?.toLowerCase()) {
                case 'pending':
                    return { text: 'Pendente', bg: 'bg-yellow-500' }
                case 'accepted':
                    return { text: 'Cadastrado', bg: 'bg-green-500' }
                case 'rejected':
                    return
                default:
                    return { text: 'Não verificado', bg: 'bg-red-500' }
            }
        },
        colorDeleteIcon(item){
            switch (item.compliance_status) {
                case 'pending':
                    return 'bg-gray-300 text-gray-500'
                case 'accepted':
                    return 'bg-red-100 text-red-500'
                default:
                    return 'border'
            }
        },
    },
};
</script>
